import React from "react";

import twMerge from "@replo/design-system/utils/twMerge";

/**
 * If shouldBlur is true, then show the visibleComponent on top of the
 * componentToBlur (which will be blurred).
 *
 * @author Max 2025-06-18
 */
export const ConditionallyBlurredComponent: React.FC<{
  visibleComponent: React.ReactNode;
  componentToBlur: React.ReactNode;
  shouldBlur?: boolean;
  blurSize?: "xs" | "sm";
  visibleComponentClassName?: string;
}> = ({
  visibleComponent,
  componentToBlur,
  shouldBlur = true,
  blurSize = "xs",
  visibleComponentClassName,
}) => {
  if (!shouldBlur) {
    return componentToBlur;
  }

  return (
    <div className="relative flex-1">
      <div
        className={twMerge(
          "flex-1 h-full pointer-events-none pl-2",
          blurSize === "xs" && "blur-xs",
          blurSize === "sm" && "blur-sm",
        )}
      >
        {componentToBlur}
      </div>
      <div
        className={twMerge(
          "absolute inset-0 flex flex-col items-center justify-start flex-1 h-full",
          visibleComponentClassName,
        )}
      >
        {visibleComponent}
      </div>
    </div>
  );
};
